import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const ProgressBar = props => {
  const {
    progress,
    label
  } = props;

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
	<Box sx={{ width: '100%', mr: 1 }}>
	  <LinearProgress variant="determinate" value={progress} color="black" />
	</Box>
	<Box sx={{ minWidth: 35 }}>
	  <Typography variant="body2" color="text.secondary">
            {label}
	  </Typography>
	</Box>
      </Box>
    </Box>
  );
}

export default ProgressBar;
